<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

@media print {
  @page {
    size: A6;
    margin: 0;
  }

  body * {
    visibility: hidden !important;
  }

  #pdf-render-container, 
  #pdf-render-container * {
    visibility: visible !important;
  }

  #pdf-render-container {
    position: absolute !important;
    left: 50% !important;
    top: 5mm !important;
    transform: translateX(-50%) !important;
    width: 148mm !important; /* Ancho completo de A6 */
    box-sizing: border-box !important;
    opacity: 1 !important;
    z-index: 9999 !important;
    display: block !important;
    background: #ffffff !important;
    padding: 0 !important; /* Sin padding en el contenedor */
    margin: 0 !important;
  }

  .boarding-pass-card {
    page-break-after: always;
    page-break-inside: avoid;
    width: 100% !important;
    margin: 0 !important;
    border-radius: 0 !important; /* Sin bordes redondeados para impresión */
  }
  
  .boarding-pass-card:last-child {
    page-break-after: avoid;
  }
}
</style>